import { Station } from '../../service/stations';
import { getRowColor } from '../../utils/functions/getRowColorStations';
import './RainfallTable.css';
import { cleanStationName } from '../../utils/functions/cleanStationName';
import {
  formatTimestampToTime,
  isOlderThanMinutes,
} from '../../utils/functions/time';
import { Legend } from './legend';
import { Chip } from './chip';
import { Cell } from './cell';
import { THead } from './thead';
import { Dash } from './dash';

type Props = {
  stations: Station[];
};

export function Table({ stations }: Props) {
  if (!stations.length) return <></>;

  return (
    <div>
      <Legend />
      <div className="table-scroll">
        <table className="rainfall-table-custom">
          <THead />
          <tbody>
            {stations.map((s) => {
              const {
                station: name,
                precipitationHour,
                precipitationDay,
                precipitationStorm,
                lastReading,
              } = s;

              const bgColor = getRowColor(precipitationHour);
              const isMaint = isOlderThanMinutes(lastReading, 60);
              const rowBg = isMaint ? '#fafafae1' : bgColor;

              return (
                <tr key={name} className={isMaint ? 'disabled' : ''}>
                  <Cell
                    className="custom-tooltip-wrapper col-station"
                    tooltip={name}
                    rowBg={rowBg}
                  >
                    <div className="station-cell">
                      <span className="station-name">
                        {cleanStationName(name)}
                      </span>
                      {isMaint && (
                        <span className="em-manutencao bg-primary-subtle text-primary">
                          Em manutenção
                        </span>
                      )}
                    </div>
                  </Cell>

                  <Cell rowBg={rowBg}>
                    <Chip
                      tone="neutral"
                      icon="bi-clock"
                      title="Hora da última leitura"
                    >
                      {isMaint ? <Dash /> : formatTimestampToTime(lastReading)}
                    </Chip>
                  </Cell>

                  <Cell rowBg={rowBg}>
                    <Chip
                      tone="rain"
                      icon="bi-umbrella"
                      title="Precipitação na última hora"
                      className="text-primary"
                    >
                      {isMaint ? <Dash /> : `${precipitationHour ?? 0} mm`}
                    </Chip>
                  </Cell>

                  <Cell className="col-num" rowBg={rowBg}>
                    <Chip
                      tone="rain"
                      icon="bi-cloud-rain"
                      title="Precipitação no dia"
                      className="text-primary"
                    >
                      {isMaint ? <Dash /> : `${precipitationDay ?? 0} mm`}
                    </Chip>
                  </Cell>

                  <Cell className="col-num" rowBg={rowBg}>
                    <Chip
                      tone="rain"
                      icon="bi-cloud-lightning"
                      title="Precipitação da tempestade"
                      className="text-primary"
                    >
                      {isMaint ? <Dash /> : `${precipitationStorm ?? 0} mm`}
                    </Chip>
                  </Cell>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <span className="d-block text-muted small mt-2 xl:mt-0 obs">
        <strong>Observação: </strong>A Precipitação de Tempestade é a soma de
        toda a chuva registrada durante um mesmo evento. A contagem é encerrada
        quando passam 24 horas seguidas sem chover.
      </span>
    </div>
  );
}
